import React from "react";
import { CSVLink } from 'react-csv';

// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";

import uuid from "uuid";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import songs from "../data/songs";

const CheckboxTable = checkboxHOC(ReactTable);

function getData() {
  const data = songs.map(item => {
    // using chancejs to generate guid
    // shortid is probably better but seems to have performance issues
    // on codesandbox.io
    const _id = uuid.v4();
    return {
      _id,
      ...item
    };
  });
  return data;
}

function getColumns() {
  return [
    {
      accessor: 'Title',
      Header: 'Title',
      sortabe: true,
      resizeable: true,
      width: 300,
      filterable: true,
      filterMethod: (filter, row) =>
        row[filter.id].startsWith(filter.value) &&
        row[filter.id].endsWith(filter.value)
    }, {
      accessor: 'Key words',
      Header: 'Keywords',
      sortabe: true,
      resizeable: true,
      width: 300
    },
    {
      accessor: 'Themes',
      Header: 'Themes',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'Function',
      Header: 'Function',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'Function/Emotion',
      Header: 'Function/Emotion',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'Writer',
      Header: 'Writer',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'Source',
      Header: 'Source',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'Year',
      Header: 'Year',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'Ideal Key(s)*',
      Header: 'Ideal Key(s)*',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'Tempo',
      Header: 'Tempo',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'Time signature',
      Header: 'Time signature',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'Range',
      Header: 'Range',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'Structure',
      Header: 'Structure',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'Style',
      Header: 'Style',
      sortabe: true,
      resizeable: true,
    }, {
      accessor: 'Difficulty rating (vocal)',
      Header: 'Difficulty rating (vocal)',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'What makes it difficult',
      Header: 'What makes it difficult',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'Addressed to',
      Header: 'Addressed to',
      sortabe: true,
      resizeable: true,
    },
    {
      accessor: 'I/we',
      Header: 'I/we',
      sortabe: true,
      resizeable: true,
    }, {
      accessor: 'Driver',
      Header: 'Driver',
      sortabe: true,
      resizeable: true,
    }
    , {
      accessor: 'Core',
      Header: 'Core',
      sortabe: true,
      resizeable: true,
    }, {
      accessor: 'Version',
      Header: 'Version',
      sortabe: true,
      resizeable: true,
    }
  ];
}

class SongGrid extends React.Component {
  constructor() {
    super();
    const data = getData();
    const columns = getColumns(data);
    this.state = {
      data,
      columns,
      selection: [],
      selectAll: false
    };
  }

  toggleSelection = (key, shift, row) => {
    setTimeout(() => {
      // start off with the existing state
      let selection = [...this.state.selection];
      const keyIndex = selection.indexOf(key);
      // check to see if the key exists
      if (keyIndex >= 0) {
        // it does exist so we will remove it using destructing
        selection = [
          ...selection.slice(0, keyIndex),
          ...selection.slice(keyIndex + 1)
        ];
      } else {
        // it does not exist so add it
        selection.push(key);
      }
      // update the state
      this.setState({ selection });
    }, 100);
  };

  toggleAll = () => {
    const selectAll = this.state.selectAll ? false : true;
    const selection = [];
    if (selectAll) {
      // we need to get at the internals of ReactTable
      const wrappedInstance = this.checkboxTable.getWrappedInstance();
      // the 'sortedData' property contains the currently accessible records based on the filter and sort
      const currentRecords = wrappedInstance.getResolvedState().sortedData;
      // we just push all the IDs onto the selection array
      currentRecords.forEach(item => {
        selection.push(item._original._id);
      });
    }
    this.setState({ selectAll, selection });
  };

  isSelected = key => {
    return this.state.selection.includes(key);
  };

  downloadSelected = () => {
    const ids = this.state.selection;
    const data = this.state.data.map(d => ({ ...d }))
      .filter(d => ids.indexOf(d._id) > -1)
      .map(d => {
        delete d._id;
        return d;
      });

    return data;
  };

  render() {
    const { toggleSelection, toggleAll,
      isSelected } = this;
    const { data, columns, selectAll, selection } = this.state;

    const checkboxProps = {
      selectAll,
      isSelected,
      toggleSelection,
      toggleAll,
      pageSize: songs.length,
      selectType: "checkbox",
      // showPaginationTop: false,
      showPaginationBottom: false,
      getTrProps: (s, r) => {
        // someone asked for an example of a background color change
        // here it is...
        if (!r || !r.original) return {};
        const selected = this.isSelected(r.original._id);
        return {
          style: {
            backgroundColor: selected ? "lightgreen" : "inherit"
            // color: selected ? 'white' : 'inherit',
          }
        };
      }
    };
    const csvData = this.downloadSelected();
    // console.log('csvData', csvData)

    return (
      <div style={{ overflowX: 'auto' }}>
        <div>
          {
            (selection.length > 0)
            ?(<CSVLink data={csvData} disabled={selection.length ===0}  >Download Songs</CSVLink>)
            : (<span>Check Selected Songs To Download</span>)
          }
        </div>
        <CheckboxTable
          ref={r => (this.checkboxTable = r)}
          data={data}
          columns={columns}
          className="-striped -highlight"
          {...checkboxProps}
        />
      </div>
    );
  }
}

export default SongGrid;
